// extracted by css-extract-rspack-plugin
var _1 = "ts";
var _2 = "tn";
var _3 = "ej";
var _4 = "to";
var _5 = "m9";
var _6 = "tr";
var _7 = "tq";
var _8 = "tp";
export { _1 as "big", _2 as "isModal", _3 as "loadingComponent", _4 as "loadingIcon", _5 as "loadingModal", _6 as "small", _7 as "smallTransparent", _8 as "spin" }
